import * as types from "./types";

export const defaultState = {
  circles: {},
  loading: {},
  errors: []
};

const circles = (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCHED_CIRCLE_DETAILS:
      let loading_circles = {...state.loading};       
      delete loading_circles[action.circle_id];    
      let existent_circles = {...state.circles};       
      existent_circles[action.circle.guid] = action.circle;
      return {
        ...state,
        circles: existent_circles,
        loading: loading_circles        
      };    
    case types.FETCHING_CIRCLE_DETAILS:      
        loading_circles = {...state.loading};       
        loading_circles[action.circle_id] = true; 
        return {
          ...state,
          loading: loading_circles
        };      
    case types.ERROR_FETCHING_CIRCLE_DETAILS:  
        loading_circles = {...state.loading};       
        delete loading_circles[action.circle_id];     
        return {
          ...state,
          errors: [...state.errors, action.error],
          loading: loading_circles
        };    
    default:
      return state;
  }
};
export default circles;
